// extracted by mini-css-extract-plugin
export default {"loader":"spinner_loader__MW8eg","spin":"spinner_spin__s3IiP"};